
import React from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home, 
  Search, 
  FileText, 
  Settings, 
  Play,
  Rocket,
  Info,
  Briefcase
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import PrefetchLink from '@/components/routing/PrefetchLink';

const MobileNav = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  if (!isMobile) return null;
  
  const navItems = [
    {
      name: 'Home',
      icon: Home,
      path: '/dashboard',
    },
    {
      name: 'Directory',
      icon: Search,
      path: '/investor-directory',
    },
    {
      name: 'Intelligence',
      icon: Info,
      path: '/investor-intelligence',
    },
    {
      name: 'Deal Room',
      icon: Briefcase,
      path: '/deal-room',
    },
    {
      name: 'Resources',
      icon: FileText,
      path: '/templates',
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border/40 shadow-lg">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          
          return (
            <PrefetchLink
              key={item.name}
              to={item.path}
              prefetch="visible"
              className={cn(
                "flex flex-col items-center justify-center p-2 rounded-md transition-colors duration-200",
                "w-full h-full", 
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <div className={cn(
                "relative flex items-center justify-center rounded-full p-1.5 mb-0.5",
                isActive ? "bg-primary/10" : "bg-transparent"
              )}>
                <item.icon 
                  size={22}
                  className={cn(
                    "transition-all duration-300", 
                    isActive ? "text-primary scale-110" : "text-muted-foreground"
                  )} 
                />
                {isActive && (
                  <span className="absolute inset-0 rounded-full animate-pulse-glow-intense bg-primary/5"></span>
                )}
              </div>
              <span className={cn(
                "text-xs font-medium transition-all duration-300",
                isActive ? "text-primary" : "text-muted-foreground"
              )}>
                {item.name}
              </span>
              {isActive && (
                <div className="absolute top-0 h-0.5 w-10 bg-gradient-to-r from-primary/40 via-primary to-primary/40 rounded-full transform -translate-y-0.5"></div>
              )}
            </PrefetchLink>
          );
        })}
      </div>
      
      {/* Add a safe area spacing for iOS devices */}
      <div className="h-safe-bottom bg-background/95"></div>
    </div>
  );
};

export default MobileNav;
